import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  bigBoxShadow,
  borderRadius16,
} from 'approot/shared/styles/borders.style';
import {
  grey1,
  grey3,
  grey5,
  grey10,
  grey7,
} from 'approot/shared/styles/colours.style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import {
  Heading16,
  Heading24,
  PStyled,
  SmallStyled,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import {
  flexCentreAlignCss,
  flexLeftAlignCss,
} from 'approot/shared/styles/flex.style';
import { PrimaryButtonLink } from 'approot/shared/styles/buttons/primary-button.style';
import { FlowSmallText } from 'approot/flows/flow.style';
import { Box } from 'approot/shared/styles/box.style';
import { SecondaryButtonLink } from 'approot/shared/styles/buttons/secondary-button.style';

export const PaywallContainer = styled.div`
  ${bigBoxShadow}
  border-radius: ${rem(borderRadius16)};
  border: 1px solid ${grey5};
  padding: ${rem(spacing24)};
  background-color: ${grey1};
  position: relative;
`;

export const PaywallHeading = styled(Heading24).attrs({
  as: 'h3',
  marginBottom: spacing24,
})``;

export const PaywallSectionTitle = styled(Heading16).attrs({
  marginBottom: 0,
  colour: grey10,
  as: 'h3',
})`
  font-weight: ${fontWeightMedium};
`;

export const PaywallText = styled(PStyled).attrs({
  marginBottom: 0,
})``;

export const PaywallSection = styled(Box).attrs({
  $marginBottom: 24,
})`
  ${flexLeftAlignCss}
`;

export const PaywallGreyCircle = styled.div`
  ${flexCentreAlignCss}

  border-radius: 50%;
  background-color: ${grey3};
  width: ${rem(32)};
  height: ${rem(32)};
  flex-shrink: 0;
  margin-right: ${rem(spacing16)};
`;

export const PaywallButtons = styled.div`
  ${PrimaryButtonLink}, ${SecondaryButtonLink} {
    width: 100%;
  }

  ${FlowSmallText} {
    text-align: center;
    margin-top: ${rem(spacing24)};
    margin-bottom: 0;
  }
`;

export const PaywallButtonSmallStyled = styled(SmallStyled).attrs({
  colour: grey7,
  marginBottom: 0,
})``;

export const PaywallButtonSmallBoldStyled = styled(PaywallButtonSmallStyled)`
  font-weight: ${fontWeightMedium};
`;
